export const PASSING_MIN = 30
export const PASSING_MAX = 100

export const NUM_QUESTIONS_MIN = 0
export const NUM_QUESTIONS_MAX = 200

export const POINTS_MIN = 1
export const POINTS_MAX = 100